export default __webpack_public_path__ + "static/media/document.d97cef27.svg";